<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<defs></defs>
		<g transform="translate(-1703.75 -329)">
			<path class="a" d="M0,0H45V45H0Z" transform="translate(1703.75 329)" />
			<path d="M13.9,25.475,6.025,17.6,3.4,20.225l10.5,10.5,22.5-22.5L33.775,5.6Z"
				transform="translate(1706.725 333.9)" />
		</g>
	</svg>
</template>

<script>
	export default {
		name: 'b-icon-done',
		components: {},
		computed: {},
		props: {},
	};
</script>

<style scoped lang="scss">
	path.a {
		fill: none;
	}
</style>

<docs>
	IconDone

	```js
	<b-icon-done />
	```
</docs>
